import { Box, Typography, Grid2 } from '@mui/material';
import { PartCardSmall } from '@qb/frontend/components/PartCards/PartCardSmall';
import { TenantConfig } from '@/shared/types/controllers/sps/SPSAppControllerTypes';
import { PartSameManufacturerPartCategoryPartsResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';
type SimilarPartsFromSameCategorySameManufacturerProps = {
  tenantConfig: TenantConfig;
  parts: PartSameManufacturerPartCategoryPartsResponse['parts'];
  categoryName: string | undefined;
  manufacturerName: string | undefined;
};
export const SimilarPartsFromSameCategorySameManufacturer = ({
  tenantConfig,
  parts,
  categoryName,
  manufacturerName
}: SimilarPartsFromSameCategorySameManufacturerProps) => {
  if (!parts?.length) {
    return null;
  }
  return <Box sx={{
    bgcolor: 'common.backgroundColor',
    boxShadow: {
      md: `-500px 0px 0px 0px var(--mui-palette-common-backgroundColor)`,
      lg: `-700px 0px 0px 0px var(--mui-palette-common-backgroundColor)`,
      xl: `-950px 0px 0px 0px var(--mui-palette-common-backgroundColor)`
    },
    mt: 4,
    py: 4,
    pr: 2,
    pl: [2, 2, 0]
  }} data-sentry-element="Box" data-sentry-component="SimilarPartsFromSameCategorySameManufacturer" data-sentry-source-file="SimilarPartsFromSameCategorySameManufacturer.tsx">
      <Typography variant="h4" component="h2" sx={{
      typography: {
        xs: 'h5',
        sm: 'h4'
      },
      mb: [1.5, 2, 3],
      pl: [1, 1, 0]
    }} data-sentry-element="Typography" data-sentry-source-file="SimilarPartsFromSameCategorySameManufacturer.tsx">
        Similar products from: {manufacturerName} {categoryName}
      </Typography>
      <Grid2 container rowSpacing={1} sx={{
      ml: {
        md: -1
      }
    }} data-sentry-element="Grid2" data-sentry-source-file="SimilarPartsFromSameCategorySameManufacturer.tsx">
        {parts.map(part => <Grid2 size={{
        xs: 12,
        sm: 6,
        md: 6,
        lg: 4
      }} key={part.id} sx={{
        px: 1
      }}>
            <PartCardSmall tenantConfig={tenantConfig} part={part} />
          </Grid2>)}
      </Grid2>
    </Box>;
};